export const getConstraint1 = (t) => ({
  compliance: {
    presence: {
      allowEmpty: false,
      message: `${t('error_emptyText')}`,
    },
  },
})
